import type { ReactNode } from 'react';
import { memo, forwardRef } from 'react';
import Label from '../Label';
import { useTheme } from '@simplywallst/ui-core';

interface ColumnProps {
  columnHeight: number;
  chartHeight: number;
  columnWidth: string;
  color: string;
  onUpdate: (y: number) => void;
  valueColor?: string;
  title: string;
  tooltip: ReactNode;
  value: number | null;
  formattedValue: string;
  typography?: keyof ReturnType<typeof useTheme>['typography'];
  x: string;
  y: number;
  zero: number;
  labelOffset: number;
  showTopBar: boolean;
}

const Column = forwardRef<SVGSVGElement, ColumnProps>(
  (
    {
      columnHeight,
      columnWidth,
      chartHeight,
      color,
      onUpdate,
      valueColor,
      title,
      tooltip,
      value,
      formattedValue,
      typography,
      x,
      y,
      zero,
      labelOffset,
      showTopBar,
    },
    ref
  ) => {
    const theme = useTheme();
    const offset = RUNTIME_ENV === 'server' ? 26 : 0;
    const resolvedY = y + offset;
    const resolvedChartHeight = chartHeight + offset;
    return (
      <svg
        ref={ref}
        x={x}
        y="0"
        width={columnWidth}
        height={resolvedChartHeight + 2 * labelOffset}
      >
        <g transform={`translate(0, ${resolvedY})`}>
          {showTopBar && columnHeight > 2 && (
            <rect
              x="0"
              y={value && value >= 0 ? 0 : columnHeight - 2}
              width="95%"
              height="2"
              fill={theme.color.bad}
            />
          )}
          <rect x="0" y="0" width="95%" height={columnHeight} fill={color} />
          <rect
            x="0"
            y={zero - 1 - resolvedY + offset}
            width="95%"
            height="1"
            fill={theme.color.white}
          />
          <Label
            tooltip={tooltip}
            title={title}
            formattedValue={formattedValue}
            negOrNull={value === null || value < 0}
            bound={columnHeight}
            valueColor={valueColor}
            onUpdate={onUpdate}
            typography={typography}
          />
        </g>
      </svg>
    );
  }
);

export default memo(Column);
